import React, {Component} from 'react';
import {Route} from 'react-router-dom'
import './OmniSearchForm.css';
import {withRouter} from "react-router";

class OmniSearchForm extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <li>
                <form className="navbar-form" role="search">
                    <div className="form-group">
                        <input type="text" className="form-control global-search"
                               placeholder="Глобальный поиск"
                               value={this.state.query}
                               onChange={event => this.setState({query: event.target.value})}
                               onKeyPress={event => this.handleQueryKeyPress(event)}/>
                    </div>
                </form>
            </li>
        );
    }

    handleQueryKeyPress(event, history) {
        if (event.key === 'Enter') {
            event.preventDefault();

            let history = this.props.history;
            history.push(`/search/${this.state.query}`);
        }
    }
}

export default withRouter(OmniSearchForm);


// WEBPACK FOOTER //
// ./src/components/OmniSearchForm.js